import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import { myAxiosAdmin } from "../../../utils/common";
import { IScoreContentInfo, IScoreContentItem } from "../adminTypes";
import clsx from "clsx";

export default function ScoresLoader() {
  const { cohortId } = useParams();
  // content listesini çek

  const { data: scoreContents } = useQuery({
    queryFn: async (): Promise<IScoreContentInfo[]> =>
      myAxiosAdmin.get(`/admin/cohort_content/${cohortId}`).then((r) => r.data),
    queryKey: ["scoreContents", { cohortId }],
  });

  const { data: cohortScores } = useQuery({
    queryFn: async (): Promise<IScoreContentItem[]> =>
      myAxiosAdmin.get(`/admin/cohort_scores/${cohortId}`).then((r) => r.data),
    queryKey: ["cohortScores", { cohortId }],
  });


  // scoreları çek
  return (
    <div className="panel max-w-7xl mx-auto p-12 rounded-2xl border mt-16 overflow-y-auto score-table">
      <div className="flex border-b border-myOrange text-center font-bold">
        <div className="w-12 text-center">%</div>
        <div className="w-54" />
        {scoreContents?.map((item) => (
          <div
            key={item.content_type + "_" + item.content_id}
            className={clsx(
              "w-8 h-8",
              Number(item.calendar_week) % 2 === 0
                ? "bg-transparent"
                : "bg-white/15"
            )}
          >
            {item.content_type === "PROJECT" ? (
              <span className="text-myOrange">P</span>
            ) : (
              <span className="text-myGreen">D</span>
            )}
          </div>
        ))}
      </div>

      {cohortScores?.map((line) => (
        <div
          key={"user_" + line.id}
          className="flex text-xs border-b border-white/20 last:border-b-0 leading-8"
        >
          <div className="w-12 font-bold text-center">{line.avg}</div>
          <div className="w-54 text-sm leading-8">{line.username} <span className="text-xs opacity-50">(id: {line.id})</span></div>
          {scoreContents?.map((item) => (
            <div
              key={item.content_type + "_" + item.content_id + "_" + line.id}
              className={clsx(
                "w-8 text-center",
                Number(item.calendar_week) % 2 === 0
                  ? "bg-transparent"
                  : "bg-white/15"
              )}
            >
              {line.scores[item.content_type + "_" + item.content_id]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
